var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.clazz},[_c('carousel',{attrs:{"perPageCustom":_vm.itemsCarousel,"mouse-drag":false,"navigationEnabled":"","navigationNextLabel":" ","navigationPrevLabel":" ","navigateTo":_vm.startPage}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }